import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, lastValueFrom } from 'rxjs';
import { routes } from '../../core.index';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class DepartmentService {
  private departmentUrl = environment.apiUrl + 'portal/departments/';
  constructor(private http: HttpClient) { }

  add(departmentDto: {name_ar: string, name_en: string}): Observable<any> {
    return this.http.post(`${this.departmentUrl}`, {...departmentDto });
  }

  update(id: number, departmentDto: {name_ar: string, name_en: string}): Observable<any> {
    return this.http.put(`${this.departmentUrl}${id}`, {...departmentDto });
  }

  delete(id: number): Observable<any> {
    return this.http.delete(`${this.departmentUrl}${id}`);
  }

  getAll(): Observable<any> {
    return this.http.get(`${this.departmentUrl}`);
  }

  getById(id: number): Observable<any> {
    return this.http.get(`${this.departmentUrl}${id}`);
  }


}
